import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { CommonService } from '../../services/common.service';
import { UserService } from '../../services/user.service';
import { ProductNetworkLocationsViewModalComponent } from './product-network-locations-view-modal/product-network-locations-view-modal.component';
import { AdministrationSummaryService } from '../../services/administration/administration-summary.service';
import { SuccessBanertemplateComponent } from 'src/app/common/success-banertemplate/success-banertemplate.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-product-network-locations',
  templateUrl: './product-network-locations.component.html',
  styleUrls: ['./product-network-locations.component.scss']
})
export class ProductNetworkLocationsComponent implements OnInit {

  columnDefs;
  operations;
  tempoperation;
  gridApi: GridApi;
  selectedRow;
  rowData;
  Statuslist:any[] =[];
  advanceSearch;
  ApplicationID: string;
  organisationType = [];
  StudyTeamOrganization: UntypedFormGroup;
  permission: string = "";
  IsMultipermission: string = "yes";
  userType: string = "";
  isSettings:boolean=false;
  collapesedOrNot:boolean=false;
  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: AdministrationSummaryService,
    private modalService: NgbModal,
    private commonService: CommonService,
    private userService: UserService,
  ) {
  }

  ngOnInit() {
   this.Statuslist.push({label : "All" , value : ""});
   this.Statuslist.push({label : "Active" , value : "1"});
   this.Statuslist.push({label : "Inactive" , value : "0"});

    this.userType = this.userService.getUserType();
    this.StudyTeamOrganization = new UntypedFormGroup({
      NAME: new UntypedFormControl(""),
      TYPE: new UntypedFormControl(""),
      STATUS:new UntypedFormControl(""),
    });

   
    this.columnDefs= [
      {
        "headerName": "Product Network Location",
        "field": "NAME"
        
      },
      
      {
        "headerName": "Status",
        "field": "Status"
      }
    ],

    this.getMasterData();

    this.tempoperation = [
     
    ];
   
    this.advanceSearch=
    {
      "fields": [
        {
          "label": "Name",
          "field": "name",
          "type": "text"
        },
        {
          "label":"STATUS",
          "field":"Status",
          "type":"dropdown"
        }
        
      ]
    }
    if(this.commonService.getScreenPermission("617","N")){
    this.tempoperation.push({
            "name": "Add Product Network Location ",
            "id": "add"
    });
  }
  if(this.commonService.getScreenPermission("617","E")){
    this.isSettings=true;
    this.tempoperation.push({
        "name": "Edit",
        "id": "edit"
    });
  }
  if(this.commonService.getScreenPermission("617","V")){
    this.isSettings=true;
    this.tempoperation.push({
      "name": "View",
      "id": "View"
    });
  }
  if(this.commonService.getScreenPermission("617","D")){
    this.isSettings=true;
    this.tempoperation.push({
       "name": "Delete",
       "id": "delete"
    });
  }

    this.operations = this.tempoperation.map(operation => {
      return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });

    this.setSummaryData();
  }
  onAdvanceSearchOperation(searchFiletrs) {
  
  }
  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
   let modelRef= this['self'].modalService.open(ProductNetworkLocationsViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass:'modal-vlg right modal-right',
      animation: true
    });
    modelRef.componentInstance.Content= {
      heading: 'View',
      content: { id: event.data['ID']}
    }
    
  }

  add() {
    let modalRef = this['self'].modalService.open(ProductNetworkLocationsViewModalComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-lg right modal-right',
        animation: true
      });
      modalRef.componentInstance.Content={
        heading: 'Add',
        content: { id: '' }
      }
      modalRef.result.then(result => {
        this['self'].setSummaryData();
      })
   
  }

  edit(Record: any) {
   let modalRef = this['self'].modalService.open(ProductNetworkLocationsViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass:'modal-lg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'Edit',
      content: { id: Record['ID']}
    }
    modalRef.result.then(result=>{
      this['self'].setSummaryData();
    })
  }
  View(Record: any) {
   let modalRef = this['self'].modalService.open(ProductNetworkLocationsViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-lg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'View',
      content: { id: Record['ID'] }
    }
    modalRef.result.then(result => {
      this['self'].setSummaryData();
    })
  }
  delete(Record: any) {
    let id = Record['ID'];
    let name = Record['NAME'];
    let message="";
    const modalRef = this['self'].modalService.open(DeleteBoxComponent, {backdrop: false});
    modalRef.componentInstance.Content=  { heading: 'Delete', 
    custommessage: 'Are you sure you want to delete the Product Network Location  ' + "'" +name + "'" + ' ?',
    ProceedButtonName:"Delete",
     TerminateButtonName:"Cancel"}
    modalRef.result.then(result => {
      if(result == "okclick")
        this["self"].summaryService.Delete('api/ProductNetworkLocations/Delete?RecordID=' + id).subscribe(summary => {
        if (summary["Status"] == 0) {
          this["self"].commonService.SuccessBanner(summary.Message);
          this['self'].setSummaryData();
        }
        else {
          this["self"].commonService.ValidationBanner(summary.Message);

        }
      });
    })
   
  }
  getMasterData() {
    this.organisationType = [];
    this.summaryService.getSummaryData('api/ProductNetworkLocations/GetMasterData').subscribe(summary => {
      this.organisationType = summary["MasterData1"];
      
    });
  }

  setSummaryData() {
    this.SearchClear();
      this.summaryService.getSummaryData('api/ProductNetworkLocations/GetSummaryData').subscribe(summary => {
        this.rowData = summary
      });
  }

  fetchSearchData(searchObject) {
    this.summaryService.AdvanceSearch('api/ProductNetworkLocations/GetSummarySearchData', searchObject).subscribe(summary => {
      this.rowData = summary
    });
  }
  //// Advace search Functions
  SearchClear() {
    this.StudyTeamOrganization.patchValue({
      NAME: "",
      STATUS: "",
      
    });
  }
  AdvanceSearch() {
    var formData = this.StudyTeamOrganization.value;
    this.fetchSearchData(formData);
  }
}
